import { getAnalytics, initializeAnalytics, isSupported, logEvent, setUserId } from 'firebase/analytics';
import { onAuthStateChanged } from 'firebase/auth';
import { app, auth } from '../config/Firebase';
import { Environment } from '../util/Environment';
import { Log } from '../util/Logging';
import { AnalyticsEvent } from './AnalyticsEvents';

export const Analytics = {
	async initialize() {
		if (!await isSupported()) {
			Log.system.warn('Analytics is not supported. Events will not be sent.');
		}

		initializeAnalytics(app, {
			config: {
				app_version: Environment.appVersion,
			}
		});

		onAuthStateChanged(auth, (user) => {
			setUserId(getAnalytics(app), user?.uid ?? null);
		});
	},

	/** 
	 * Log a Firebase/Google Analytics event. Best-effort: analytics must never break the app it's attached to,
	 * and the environment (e.g. tests) may not support it at all. 
	 */
	track<Name extends keyof AnalyticsEvent>(
		name: Name,
		...params: AnalyticsEvent[Name] extends undefined ? [] | [undefined] : [AnalyticsEvent[Name]]
	) {
		Log.analytics.debug(`track ${name}, ${JSON.stringify(params[0])}`);
		logEvent(getAnalytics(app), name as string, params[0]);
	}
};
